import { useTranslation } from 'react-i18next';

interface DimensionFilterNoticeProps {
  /** Nombre de la dimensión seleccionada; `null` o vacío no renderiza nada. */
  dimensionName?: string | null;
  /**
   * Clave de i18n del texto. Por defecto advierte que los indicadores de participación no se
   * desglosan por dimensión; los bloques que el backend no puede filtrar pasan
   * `analytics.dimensionFilter.notApplicable`.
   */
  messageKey?: string;
}

/**
 * Aviso de que el filtro por comportamiento está activo y qué alcance tiene sobre el bloque que
 * lo acompaña. Sin él, un indicador global junto a una tabla filtrada se lee como un dato
 * inconsistente.
 */
export function DimensionFilterNotice({
  dimensionName,
  messageKey = 'analytics.dimensionFilter.partialScope',
}: DimensionFilterNoticeProps) {
  const { t } = useTranslation();

  if (!dimensionName) return null;

  return (
    <div className="au-dim-notice" role="note">
      <i className="fas fa-filter" aria-hidden="true" />
      <span>{t(messageKey, { dimension: dimensionName })}</span>
    </div>
  );
}
